import React, { useEffect, useState, forwardRef, Ref, useImperativeHandle } from 'react';
import BadgesComponent from '@components/common/Badges';
import './edit.css';
import { stateList, districtList, blockList, villageList, wardList, ulbList } from '@constants/index';
import { healthBlockSubDivLocationDetails, healthBlockDivisionDetails } from '../../../../constants/index'
import { useSelector } from 'react-redux';
import FormFields from "../../../Forms/CommonFormFields"
import RadioButtonComponent from '@components/common/Radios';
import axios from '../../../../utils/axiosExt';
import { manageHealthFacilityJson, validations } from '../nonGeoValidations';
import endpoints from '@config/endpoints';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import { getData, putDataJSON } from '@services/CommonApiService';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Auth from "../../../../utils/auth";
import { toast } from 'react-toastify';
import { errorLogger } from '@utils/applicationLogUtils';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
import _ from 'lodash';
import { uint8ToBase64 } from '@utils/base64Utils';
import pako from 'pako';

interface objectType {
  healthBlockSubDiv: any;
}

interface objectTypes {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?: any,
  verifiedDetails?: any
  code?: any
}
interface formStateType {
  [key: string]: objectTypes
}

const isClickedStyle: any = {
  background: 'lightgrey',
  color: '#af2d94'
}
export const useUpperComponent = () => {
  const [state, setState] = useState('correction');
  const component = <div className="upper-component">
    <span style={{ margin: "0.5rem" }}>
      <RadioButtonComponent
        onRadioButtonChange={() => setState('correction')}
        radioName={'Correction'}
        radioValue={state}
        radioButtonGroup={'Group'}
        defaultChecked={true}
      />
    </span>
    <span style={{ margin: "0.5rem" }}>
      <RadioButtonComponent
        onRadioButtonChange={() => setState('upgrade')}
        radioName={'Upgrade'}
        radioButtonGroup={'Group'}
      />
    </span>
  </div>;

  return [component, state];
};

export interface ChildComponentHandlerUpdateHealthBlockSubDiv {
  handleUpdateSave: () => void;
}

const HealthBlockSubDivUpdateUpgrade = forwardRef((props: objectType, ref: Ref<ChildComponentHandlerUpdateHealthBlockSubDiv>) => {
  const { healthBlockSubDiv } = props;
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [distId, setDistId] = useState<string>("");
  const [stateId, setStateId] = useState<string>("");
  const [healthBlockName, setHealthBlockName] = useState<string>("");
  const [healthBlockDetails, setHealthBlockDetails] = useState<any>([]);
  const [isGramPanchayat, setIsGramPanchayat] = useState<boolean>(false);
  const [healthBlockSubDivForm, setHealthBlockSubDivForm] = useState<formStateType>({
    type_name: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },
    effectiveFromDate: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    }
  });
  const [healthBlockSubDivLocationForm, setHealthBlockSubDivLocationForm] = useState<formStateType>({
    district: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },

    sub_district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: ''
    },

    ulb: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: ''
    },
    wards_mapped: {
      isError: false,
      message: '',
      isDisable: true,
      value: [],
      id: [],
      code: []
    },

    block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: ''
    },
    villages_mapped: {
      isError: false,
      message: '',
      isDisable: true,
      value: [],
      id: [],
      code: []
    },
    gram_panchayat_mapped: {
      isError: false,
      message: '',
      isDisable: true,
      value: [],
      id: [],
      code: []
    },
    health_block_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
  })
  const [healthBlockSubDivLocationData, setHealthBlockSubDivLocationData] = useState(healthBlockSubDivLocationDetails);
  const [healthBlockSubDivData, setHealthBlockSubDivData] = useState(healthBlockDivisionDetails);
  const [ulbInputText, setUlbInputText] = useState<string>('');
  const [wardsDropDownData, setWardsDropDownData] = useState<any>([]);
  const [ulbDropDownData, setUlbDropDownData] = useState<any>([]);
  const [stateCode, setStateCode] = useState('');
  const [villages_mappedDropDownData, setViillagesMappedDropDownData] = useState<any>([]);
  const [blockDropDownData, setBlockDropDownData] = useState<any>([]);
  const [sub_districtDropDownData, setSubDistrictDropDownData] = useState<any>([]);
  const [grampanchayatDropDownData, setGrampanchayatDropDownData] = useState<any>([]);
  const [hasBlocksForDistrict, setHasBlocksForDistrict] = useState<boolean | null>(null);

  useImperativeHandle(ref, () => ({
    handleUpdateSave() {
      onHandleSave();

    }
  }));


  useEffect(() => {
    const blockSatisfied = hasBlocksForDistrict === false ? true : healthBlockSubDivLocationForm.block.id.length > 0;
    if (healthBlockSubDivLocationForm.district.id.length && healthBlockSubDivLocationForm.sub_district.id.length && blockSatisfied) {
      isGramPanchayat ? getGramPanchayatByStateDistSubDisBlockId(stateId, healthBlockSubDivLocationForm.district.id, healthBlockSubDivLocationForm.sub_district.id, healthBlockSubDivLocationForm.block.id, []) : getVillagesByStateDistSubDisBlockId(stateId, healthBlockSubDivLocationForm.district.id, healthBlockSubDivLocationForm.sub_district.id, healthBlockSubDivLocationForm.block.id, []);
      !isGramPanchayat && setHealthBlockSubDivLocationData((healthBlockSubDivLocationData: any) => ({
        ...healthBlockSubDivLocationData,
        villages_mapped: {
          ...healthBlockSubDivLocationData.villages_mapped,
          '#isDisabled': false,
        }
      }));
      isGramPanchayat && setHealthBlockSubDivLocationData((healthBlockSubDivLocationData: any) => ({
        ...healthBlockSubDivLocationData,
        gram_panchayat_mapped: {
          ...healthBlockSubDivLocationData.gram_panchayat_mapped,
          '#isDisabled': false,
        }
      }));
    } else {
      !isGramPanchayat && setHealthBlockSubDivLocationData((healthBlockSubDivLocationData: any) => ({
        ...healthBlockSubDivLocationData,
        villages_mapped: {
          ...healthBlockSubDivLocationData.villages_mapped,
          '#isDisabled': true,
          '#options': [],
        }
      }));
      isGramPanchayat && setHealthBlockSubDivLocationData((healthBlockSubDivLocationData: any) => ({
        ...healthBlockSubDivLocationData,
        gram_panchayat_mapped: {
          ...healthBlockSubDivLocationData.gram_panchayat_mapped,
          '#isDisabled': true,
          '#options': [],
        }
      }));
    }
  }, [healthBlockSubDivLocationForm.district.value, healthBlockSubDivLocationForm.block.value, healthBlockSubDivLocationForm.sub_district.value, hasBlocksForDistrict]);

  useEffect(() => {
    if (healthBlockSubDivLocationForm.ulb.id.length) {
      getWardsMappedByUlbId(stateId, healthBlockSubDivLocationForm.ulb.id, []);
      setHealthBlockSubDivLocationData((healthBlockSubDivLocationData: any) => ({
        ...healthBlockSubDivLocationData,
        wards_mapped: {
          ...healthBlockSubDivLocationData.wards_mapped,
          '#isDisabled': false,
        }
      }));
    } else {
      setHealthBlockSubDivLocationData((healthBlockSubDivLocationData: any) => ({
        ...healthBlockSubDivLocationData,
        wards_mapped: {
          ...healthBlockSubDivLocationData.wards_mapped,
          '#isDisabled': true,
          '#options': [],
        }
      }));
      setHealthBlockSubDivLocationData((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        ULB: {
          ...hierarchy_details_urban.ULB,
          '#options': [],
        }
      }));
    }
  }, [healthBlockSubDivLocationForm.ulb.value]);

  useEffect(() => {
    const villagesLength = healthBlockSubDivLocationForm.villages_mapped.value.length;
    const gramPanchayatLength = healthBlockSubDivLocationForm.gram_panchayat_mapped.value.length;
    const wardsLength = healthBlockSubDivLocationForm.wards_mapped.value.length;

    const mainLocationLength = isGramPanchayat ? gramPanchayatLength : villagesLength;

    if (mainLocationLength === 0 && wardsLength === 0) {      
      setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
        ...healthBlockDivision_details,
        villages_mapped: {
          ...healthBlockDivision_details.villages_mapped,
          '#required': true
        },
        gram_panchayat_mapped: {
          ...healthBlockDivision_details.gram_panchayat_mapped,
          '#required': true
        },
        wards_mapped: {
          ...healthBlockDivision_details.wards_mapped,
          '#required': true
        },
      }));
    }
    else if (mainLocationLength === 0 && wardsLength > 0) {
      setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
        ...healthBlockDivision_details,
        villages_mapped: {
          ...healthBlockDivision_details.villages_mapped,
          '#required': false,
        },
        gram_panchayat_mapped: {
          ...healthBlockDivision_details.gram_panchayat_mapped,
          '#required': false
        },
        wards_mapped: {
          ...healthBlockDivision_details.wards_mapped,
          '#required': true
        },
      }));
      setHealthBlockSubDivLocationForm((healthBlockDivision_details: any) => ({
        ...healthBlockDivision_details,
        villages_mapped: {
          ...healthBlockDivision_details.villages_mapped,
          'isError': false,
        },
        gram_panchayat_mapped: {
          ...healthBlockDivision_details.gram_panchayat_mapped,
          'isError': false
        },
      }))
    }
    else if (mainLocationLength > 0 && wardsLength === 0) {
      setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
        ...healthBlockDivision_details,
        villages_mapped: {
          ...healthBlockDivision_details.villages_mapped,
          '#required': true
        },
        gram_panchayat_mapped: {
          ...healthBlockDivision_details.gram_panchayat_mapped,
          '#required': true
        },
        wards_mapped: {
          ...healthBlockDivision_details.wards_mapped,
          '#required': false
        },
      }));
      
      setHealthBlockSubDivLocationForm((healthBlockDivision_details: any) => ({
        ...healthBlockDivision_details,
        wards_mapped: {
          ...healthBlockDivision_details.wards_mapped,
          'isError': false,
        },
      }))
    }
    else {      
      setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
        ...healthBlockDivision_details,
        villages_mapped: {
          ...healthBlockDivision_details.villages_mapped,
          '#required': true
        },
        gram_panchayat_mapped: {
          ...healthBlockDivision_details.gram_panchayat_mapped,
          '#required': true
        },
        wards_mapped: {
          ...healthBlockDivision_details.wards_mapped,
          '#required': true
        },
      }));
    }
  }, [healthBlockSubDivLocationForm.villages_mapped.value, healthBlockSubDivLocationForm.gram_panchayat_mapped.value, healthBlockSubDivLocationForm.wards_mapped.value])

  const handleLocationForm = async (value: string | boolean, key: string, option?: any, id?: any, code?: any) => {
    setHealthBlockSubDivLocationForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code
      },
    }));
  }

  const handleHealthBlockSubDivFormChange = (value: any, key: string, option: any, code: any, id: any,) => {
    setHealthBlockSubDivForm((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        isError: false,
        message: '',
        id: id,
        code: code
      },
    }));
  }


  const getSubDistrictByDistrictId = async (distId: string) => {
    if (distId) {
      try {
        const subDistrictsList = await axios.getWithCache(`${endpoints.getSubDistricts(distId)}`, Auth.loggedIn());
        setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
          ...healthBlockDivision_details,
          sub_district: {
            ...healthBlockDivision_details.sub_district,
            '#options': subDistrictsList.data.data.map((key: any) => ({
              value: `${key.sub_district_name}-${key.sub_district_code}`,
              label: `${key.sub_district_name}-${key.sub_district_code}`,
              id: key.sub_district_id,
              code: key.sub_district_code
            })),
          },
        }));
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }
  }

  // const getULBByStateId = async (state_id:string) => {
  //   if(state_id){
  //     const ulbLists = await axios.getWithCache(`${endpoints.getUlb}/${state_id}`, Auth.loggedIn());
  //     setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
  //       ...healthBlockDivision_details,
  //       ULB: {
  //         ...healthBlockDivision_details.ULB,
  //         '#options': ulbLists.data.data.map((key: any) => ({
  //           value: `${key.ulb_name}-${key.ulb_code}`,
  //           label: `${key.ulb_name}-${key.ulb_code}`,
  //           id: key.ulb_id,
  //           code: key.ulb_code
  //         })),
  //       },
  //     }));
  //   }
  // }

  const getBlockByDistrictId = async (distId: string) => {
    if (distId) {
      try {
        const blocksList = await axios.getWithCache(`${endpoints.getBlock(distId)}`, Auth.loggedIn());
        setHasBlocksForDistrict(blocksList.data.data.length > 0);
        setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
          ...healthBlockDivision_details,
          block: {
            ...healthBlockDivision_details.block,
            '#options': blocksList.data.data.map((key: any) => ({
              value: `${key.block_name}-${key.block_code}`,
              label: `${key.block_name}-${key.block_code}`,
              id: key.block_id,
              code: key.block_code
            })),
          },
        }));
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }
  }


  const getVillagesByStateDistSubDisBlockId = async (state_id: string, dist_id: string, subDistrictIds: any, blockIds: any, hbsd_ids: any) => {
    if (state_id && dist_id) {
      try {
        const postData = {
          p_state_id: state_id,
          p_dist_id: dist_id,
          p_sub_dist_ids: subDistrictIds.length > 0  ? subDistrictIds: [],
          p_block_ids: blockIds.length > 0  ? blockIds: [],
          p_hbsd_ids: hbsd_ids.length > 0  ? hbsd_ids : [],
        }
        const villageList = await axios.post(`${endpoints.getVillagesByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
        setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
          ...healthBlockDivision_details,
          villages_mapped: {
            ...healthBlockDivision_details.villages_mapped,
            '#options': villageList.data.data.map((key: any) => ({
              value: `${key.village_name}-${key.village_code}`,
              label: `${key.village_name}-${key.village_code}`,
              id: key.village_id,
              code: key.village_code
            })),
          },
        }));
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }
  }
  const getGramPanchayatByStateDistSubDisBlockId = async (state_id: string, dist_id: string, subDistrictIds: any, blockIds: any, hbsd_ids: any) => {
    if (state_id && dist_id) {
      try {
        const postData = {
          p_state_id: state_id,
          p_dist_id: dist_id,
          p_sub_dist_ids: subDistrictIds ?? [],
          p_block_ids: blockIds ?? [],
          p_hbsd_ids: hbsd_ids ?? [],
        }
        const grampanchayatList = await axios.post(`${endpoints.getGrampanchayatByStateDistSubDisBlockId}`, postData, Auth.loggedInWithJSON());
        setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
          ...healthBlockDivision_details,
          gram_panchayat_mapped: {
            ...healthBlockDivision_details.gram_panchayat_mapped,
            '#options': grampanchayatList.data.data.map((key: any) => ({
              value: `${key.gram_panchayat_name}-${key.gram_panchayat_code}`,
              label: `${key.gram_panchayat_name}-${key.gram_panchayat_code}`,
              id: key.gram_panchayat_id,
              code: key.gram_panchayat_code
            })),
          },
        }));
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }
  }

  const getWardsMappedByUlbId = async (state_id: string, ulbIds: any, hbsd_ids: any) => {
    if (state_id) {
      try {
        const postData = {
          p_state_id: state_id,
          p_ulb_ids: ulbIds ?? [],
          p_hbsd_ids: hbsd_ids ?? []
        }
        const wardList = await axios.post(`${endpoints.getWardsByStateUlb}`, postData, Auth.loggedInWithJSON());
        setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
          ...healthBlockDivision_details,
          wards_mapped: {
            ...healthBlockDivision_details.wards_mapped,
            '#options': wardList.data.data.map((key: any) => ({
              value: `${key.ward_name}-${key.ward_code}`,
              label: `${key.ward_name}-${key.ward_code}`,
              id: key.ward_id,
              code: key.ward_code
            })),
          },
        }));
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }
  }


  const [Component, state] = useUpperComponent();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const storedUserId = localStorage.getItem('userId');
        const res = await getData<any[]>(`${endpoints.getUserById}/${storedUserId}`)
        const state_id = res.data[0].state_id;
        setStateId(res.data[0].state_id);
        const healthBlockDetail = await axios.get(`${endpoints.getHealthBlockandSubDivByHBSDId(id)}`, Auth.loggedIn());
        const healthBlockDetails = healthBlockDetail?.data?.data[0];
        setHealthBlockDetails(healthBlockDetails);
        setDistId(healthBlockDetails?.district_id);
        setHealthBlockName(healthBlockDetails.hbsd_name);
        let grampanchayat: boolean = false;
        const stateCode = healthBlockDetails?.st_code;
        setStateCode(stateCode);
        grampanchayat = await isUsingGramPanchayatUtils(stateCode);
        setIsGramPanchayat(grampanchayat)
        if (grampanchayat) {
          setHealthBlockSubDivLocationData((healthBlockSubDivLocationData: any) => ({
            ...healthBlockSubDivLocationData,
            villages_mapped: {
              ...healthBlockSubDivLocationData.villages_mapped,
              '#isVisible': false,
            },
            gram_panchayat_mapped: {
              ...healthBlockSubDivLocationData.gram_panchayat_mapped,
              '#isVisible': true,
            }
          }));
        }
        else {
          setHealthBlockSubDivLocationData((healthBlockSubDivLocationData: any) => ({
            ...healthBlockSubDivLocationData,
            villages_mapped: {
              ...healthBlockSubDivLocationData.villages_mapped,
              '#isVisible': true,
            },
            gram_panchayat_mapped: {
              ...healthBlockSubDivLocationData.gram_panchayat_mapped,
              '#isVisible': false,
            }
          }));
        }
        try {
          await getSubDistrictByDistrictId(healthBlockDetails?.district_id);
          await getBlockByDistrictId(healthBlockDetails?.district_id);
          // await getULBByStateId(state_id);
          // grampanchayat ? await getGramPanchayatByStateDistSubDisBlockId(state_id, healthBlockDetails?.district_id, [], [], []) : await getVillagesByStateDistSubDisBlockId(state_id, healthBlockDetails?.district_id, [], [], []);
          // await getWardsMappedByUlbId(state_id, [], []);

        } catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error)
        }
        if (healthBlockDetails.type_name === 'Health Block') {
          setHealthBlockSubDivLocationData((prevState: any) => ({
            ...prevState,
            ['health_block_name']: {
              ...prevState['health_block_name'],
              '#title': 'Health Block Name'
            },
          }));
        }
        else {
          setHealthBlockSubDivLocationData((prevState: any) => ({
            ...prevState,
            ['health_block_name']: {
              ...prevState['health_block_name'],
              '#title': 'Sub Division Name'
            },
          }));
        }
        setHealthBlockSubDivForm((healthBlockSubDivState: any) => ({
          ...healthBlockSubDivState,
          type_name: {
            ...healthBlockSubDivState.type_name,
            value: healthBlockDetails.type_name,
            id: healthBlockDetails.type_id
          },
          effectiveFromDate: {
            ...healthBlockSubDivState.effectiveFromDate,
            value: dayjs(healthBlockDetails.effective_from_dt)?.format('DD-MM-YYYY')
          }
        }));
        setHealthBlockSubDivLocationForm((healthBlockSubDivState: any) => ({
          ...healthBlockSubDivState,
          health_block_name: {
            ...healthBlockSubDivState.health_block_name,
            value: healthBlockDetails.hbsd_name,
            id: healthBlockDetails.hbsd_id,
            code: healthBlockDetails.hbsd_code
          },
          district: {
            ...healthBlockSubDivState.district,
            value: `${healthBlockDetails.district_name}-${healthBlockDetails.district_code}`,
            id: healthBlockDetails.district_id,
            code: healthBlockDetails.district_code
          },

        }));
        if (grampanchayat) {
          try {
            const grampanchayatList = await axios.get(`${endpoints.getGramPanchayatsByHBSDId(id)}`, Auth.loggedIn());
            const grampanchayatDetails = grampanchayatList?.data?.data;
            const gramPanchayatValue = grampanchayatDetails?.map((value: any) => `${value.gram_panchayat_name}-${value.gram_panchayat_code}`);
            const gramPanchayatCode = grampanchayatDetails?.map((value: any) => value.gram_panchayat_code);
            const gramPanchayatId = grampanchayatDetails?.map((value: any) => value.gram_panchayat_id);
            setHealthBlockSubDivLocationForm((healthBlockSubDivState: any) => ({
              ...healthBlockSubDivState,
              gram_panchayat_mapped: {
                ...healthBlockSubDivState.gram_panchayat_mapped,
                value: gramPanchayatValue,
                id: gramPanchayatId,
                code: gramPanchayatCode
              },
            }));
            setGrampanchayatDropDownData(grampanchayatList.data.data.map((key: any) => ({
              value: `${key.gram_panchayat_name}-${key.gram_panchayat_code}`,
              label: `${key.gram_panchayat_name}-${key.gram_panchayat_code}`,
              id: key.gram_panchayat_id,
              code: key.gram_panchayat_code
            })));
          } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
          }
        }
        else {
          try {
            const villageList = await axios.get(`${endpoints.getVillagesByHBSDId(id)}`, Auth.loggedIn());
            const villageDetails = villageList?.data?.data;
            const villageValue = villageDetails?.map((value: any) => `${value.village_name}-${value.village_code}`);
            const villageCode = villageDetails?.map((value: any) => value.village_code);
            const villageId = villageDetails?.map((value: any) => value.village_id);
            setHealthBlockSubDivLocationForm((healthBlockSubDivState: any) => ({
              ...healthBlockSubDivState,
              villages_mapped: {
                ...healthBlockSubDivState.villages_mapped,
                value: villageValue,
                id: villageId,
                code: villageCode
              },
            }));
            setViillagesMappedDropDownData(villageList.data.data.map((key: any) => ({
              value: `${key.village_name}-${key.village_code}`,
              label: `${key.village_name}-${key.village_code}`,
              id: key.village_id,
              code: key.village_code
            })));

            setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
              ...healthBlockDivision_details,
              villages_mapped: {
                ...healthBlockDivision_details.villages_mapped,
                '#options': villageList.data.data.map((key: any) => ({
                  value: `${key.village_name}-${key.village_code}`,
                  label: `${key.village_name}-${key.village_code}`,
                  id: key.village_id,
                  code: key.village_code
                })),
              },
            }))

          } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
          }
        }
        try {
          const wardList = await axios.get(`${endpoints.getWardsByHBSDId(id)}`, Auth.loggedIn());
          const wardDetails = wardList?.data?.data;
          const wardValue = wardDetails?.map((value: any) => `${value.ward_name}-${value.ward_code}`);
          const wardCode = wardDetails?.map((value: any) => value.ward_code);
          const wardId = wardDetails?.map((value: any) => value.ward_id);
          setHealthBlockSubDivLocationForm((healthBlockSubDivState: any) => ({
            ...healthBlockSubDivState,
            wards_mapped: {
              ...healthBlockSubDivState.wards_mapped,
              value: wardValue,
              id: wardId,
              code: wardCode
            },
          }));
          setWardsDropDownData(wardList.data.data.map((key: any) => ({
            value: `${key.ward_name}-${key.ward_code}`,
            label: `${key.ward_name}-${key.ward_code}`,
            id: key.ward_id,
            code: key.ward_code
          })));
          setHealthBlockSubDivLocationData((healthBlockDivision_details: any) => ({
            ...healthBlockDivision_details,
            wards_mapped: {
              ...healthBlockDivision_details.wards_mapped,
              '#options': wardList.data.data.map((key: any) => ({
                value: `${key.ward_name}-${key.ward_code}`,
                label: `${key.ward_name}-${key.ward_code}`,
                id: key.ward_id,
                code: key.ward_code
              })),
            },
          }));
        } catch (error: any) {
          errorLogger(error?.response?.data || error?.response || error)
        }

        setIsLoading(false);
      }
      catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }


    }

    fetchData();




  }, [])

  useEffect(() => {
    if (state === "upgrade") {
      const dateFormat = new Date(healthBlockDetails?.effective_from_dt);
      dateFormat.setDate(dateFormat.getDate() + 1);
      const newDate = dateFormat.toISOString().split('T')[0]
      setHealthBlockSubDivData((handleHealthBlockSubDiv: any) => ({
        ...handleHealthBlockSubDiv,
        effective_form_date: {
          ...handleHealthBlockSubDiv.effective_form_date,
          '#isDisabled': false,
          '#type': 'date',
          '#title': 'Effective From Date',
          '#webform_key': 'effectiveFromDate',
          '#required': true,
          '#minDate': dayjs(newDate)
        }
      }))
      setHealthBlockSubDivForm((healthBlockSubDivLocationForm: any) => ({
        ...healthBlockSubDivLocationForm,
        effectiveFromDate: {
          ...healthBlockSubDivLocationForm.effectiveFromDate,
          value: dayjs(healthBlockDetails?.effective_from_dt)
        }
      }));
    }

    else {
      setHealthBlockSubDivData((handleHealthBlockSubDiv: any) => ({
        ...handleHealthBlockSubDiv,
        effective_form_date: {
          ...handleHealthBlockSubDiv.effective_form_date,
          '#isDisabled': true,
          '#title': 'Effective From Date',
          '#type': 'textfield',
          '#webform_key': 'effectiveFromDate',
          '#required': true,

        }
      }))

      setHealthBlockSubDivForm((healthBlockSubDivLocationForm: any) => ({
        ...healthBlockSubDivLocationForm,
        effectiveFromDate: {
          ...healthBlockSubDivLocationForm.effectiveFromDate,
          value: dayjs(healthBlockDetails?.effective_from_dt).format('DD-MM-YYYY')
        }
      }));
    }
  }, [state]);

  const handleInputChange = _.debounce((value: string, key: string) => {
    if (key === 'ulb') {
      setUlbInputText(value.trim());
    }
  }, 500);

  const fecthUlbBySearch = async (ulbInputText: string) => {
    const payload = {
      stateId: stateId,
      searchText: ulbInputText,
    }
    const getUlbwithsearch = await axios.get(`${endpoints.fetchUlbByStateIdAndSearch(stateId, ulbInputText)}`, Auth.loggedIn());
    const getUlb_options = getUlbwithsearch?.data.data?.map((key: any) => ({
      value: `${key.ulb_name}-${key.ulb_code}`,
      label: `${key.ulb_name}-${key.ulb_code}`,
      id: key.ulb_id,
      code: key.ulb_code,
    }));
    setHealthBlockSubDivLocationData((hierarchy_details_urban: any) => ({
      ...hierarchy_details_urban,
      ULB: {
        ...hierarchy_details_urban.ULB,
        '#options': getUlb_options,
        '#required': false,
        '#isDisabled': false,
      },
    }));
  }
  useEffect(() => {
    if (stateId && ulbInputText?.length >= 3) {
      fecthUlbBySearch(ulbInputText)
    }
    if (ulbInputText?.length === 0) {
      setHealthBlockSubDivLocationData((hierarchy_details_urban: any) => ({
        ...hierarchy_details_urban,
        ulb: {
          ...hierarchy_details_urban.ulb,
          '#options': [],
        },
      }));
    }
  }, [ulbInputText])

  const onHandleSave = async () => {
    //debugger;
    const healthBlockDubDivFormError = {
      ...healthBlockSubDivLocationForm
    };
    const healthBlockSubDivFormError = {
      ...healthBlockSubDivForm
    };
    let isSimilarName = false;
    let ishealthBLockSubDivFormError = false;
    if (healthBlockSubDivLocationForm.health_block_name.value !== '' && healthBlockSubDiv.name !== healthBlockSubDivLocationForm.health_block_name.value) {
      try {
        const response = await axios.get(`${endpoints.checkHealthBlockSubDivExist(distId,healthBlockSubDivLocationForm.health_block_name.value)}`, Auth.loggedIn());
        const data1 = response.data?.data[0];
        isSimilarName = data1?.check_healthblock_subdiv_exists


      }
      catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }

    Object.keys(healthBlockDubDivFormError).map((item) => {
      if (item === 'health_block_name') {

        if (!healthBlockDubDivFormError.health_block_name.value) {
          healthBlockDubDivFormError.health_block_name.isError = true;
          ishealthBLockSubDivFormError = true;
          if (healthBlockSubDivForm.type_name.value === 'Health Block') {
            healthBlockDubDivFormError.health_block_name.message = validations['health_block_name']
          }
          else {
            healthBlockDubDivFormError.health_block_name.message = validations['sub_division']
          }
        }
        else if (isSimilarName && healthBlockName !== healthBlockDubDivFormError.health_block_name.value) {
          healthBlockDubDivFormError.health_block_name.isError = true;
          ishealthBLockSubDivFormError = true;
          healthBlockDubDivFormError.health_block_name.message = validations['healthBlock_exists'];
        }
        else {

          healthBlockDubDivFormError.health_block_name.isError = false;
        }
      }

      else if (!isGramPanchayat) {
        if (item === 'villages_mapped' || item === 'wards_mapped') {
          if (healthBlockDubDivFormError.villages_mapped.value.length === 0 && healthBlockDubDivFormError.wards_mapped.value.length === 0) {
            healthBlockDubDivFormError.villages_mapped.isError = true;
            ishealthBLockSubDivFormError = true;
            healthBlockDubDivFormError.villages_mapped.message = validations['villages'];
            healthBlockDubDivFormError.wards_mapped.isError = true;
            healthBlockDubDivFormError.wards_mapped.message = validations['wards'];
          }
          else if (healthBlockDubDivFormError?.villages_mapped?.value?.length === 0 && healthBlockDubDivFormError?.wards_mapped?.value?.length > 0) {
            healthBlockDubDivFormError.villages_mapped.isError = false;
            healthBlockDubDivFormError.wards_mapped.isError = false;
            healthBlockDubDivFormError.villages_mapped.message = ``;
            healthBlockDubDivFormError.wards_mapped.message = ``;
          }
          else if (healthBlockDubDivFormError?.villages_mapped?.value?.length > 0 && healthBlockDubDivFormError?.wards_mapped?.value?.length === 0) {
            healthBlockDubDivFormError.villages_mapped.isError = false;
            healthBlockDubDivFormError.wards_mapped.isError = false;
            healthBlockDubDivFormError.villages_mapped.message = ``;
            healthBlockDubDivFormError.wards_mapped.message = ``;
          }
          else {
            healthBlockDubDivFormError.wards_mapped.isError = false;
            healthBlockDubDivFormError.villages_mapped.isError = false;
          }
        }
      }
      else if (isGramPanchayat) {
        if (item === 'gram_panchayat_mapped' || item === 'wards_mapped') {
          if (healthBlockDubDivFormError.gram_panchayat_mapped.value.length === 0 && healthBlockDubDivFormError.wards_mapped.value.length === 0) {
            healthBlockDubDivFormError.gram_panchayat_mapped.isError = true;
            ishealthBLockSubDivFormError = true;
            healthBlockDubDivFormError.gram_panchayat_mapped.message = validations['gram_panchayat'];
            healthBlockDubDivFormError.wards_mapped.isError = true;
            healthBlockDubDivFormError.wards_mapped.message = validations['wards'];
          }
          else if (healthBlockDubDivFormError?.gram_panchayat_mapped?.value?.length === 0 && healthBlockDubDivFormError?.wards_mapped?.value?.length > 0) {
            healthBlockDubDivFormError.gram_panchayat_mapped.isError = false;
            healthBlockDubDivFormError.wards_mapped.isError = false;
            healthBlockDubDivFormError.gram_panchayat_mapped.message = ``;
            healthBlockDubDivFormError.wards_mapped.message = ``;
          }
          else if (healthBlockDubDivFormError?.gram_panchayat_mapped?.value?.length > 0 && healthBlockDubDivFormError?.wards_mapped?.value?.length === 0) {
            healthBlockDubDivFormError.gram_panchayat_mapped.isError = false;
            healthBlockDubDivFormError.wards_mapped.isError = false;
            healthBlockDubDivFormError.gram_panchayat_mapped.message = ``;
            healthBlockDubDivFormError.wards_mapped.message = ``;
          }
          else {
            healthBlockDubDivFormError.wards_mapped.isError = false;
            healthBlockDubDivFormError.gram_panchayat_mapped.isError = false;
          }
        }
      }
    })
    setHealthBlockSubDivLocationForm(healthBlockDubDivFormError);
    Object.keys(healthBlockSubDivFormError).map((item) => {

      if (item === 'effectiveFromDate') {
        if (!healthBlockSubDivFormError.effectiveFromDate.value) {
          healthBlockSubDivFormError.effectiveFromDate.isError = true;
          ishealthBLockSubDivFormError = true;
          healthBlockSubDivFormError.effectiveFromDate.message = validations['effectiveFromDate']
        }
        else {
          healthBlockSubDivFormError.effectiveFromDate.isError = false;
        }
      }
    })
    setHealthBlockSubDivForm(healthBlockSubDivFormError);


    if (!ishealthBLockSubDivFormError) {

      try {
        let date = dayjs(healthBlockSubDivForm.effectiveFromDate.value).format('YYYY-MM-DD');

        if (state !== "upgrade") {
          dayjs.extend(customParseFormat);
          date = dayjs(healthBlockSubDivForm.effectiveFromDate.value, "DD-MM-YYYY").format('YYYY-MM-DD');

        }

        const payload: any = {
          "hbSdId": id,
          // "hbSdCode":healthBlockById[user.id][0]?.hbsd_code,
          "stCode": Number(stateCode),
          "districtId": healthBlockSubDivLocationForm.district.id,
          "hbSdName": healthBlockSubDivLocationForm.health_block_name.value,
          "typeId": healthBlockSubDivForm.type_name.id,
          "effectiveFromDt": date,
          "villageIds": !isGramPanchayat ? healthBlockSubDivLocationForm.villages_mapped.id : [],//user?.villages?.map((village: any) => village.village_id) ?? [],
          "gramPanchayatIds": isGramPanchayat ? healthBlockSubDivLocationForm.gram_panchayat_mapped.id : [],//user?.villages?.map((village: any) => village.village_id) ?? [],
          "wardIds": healthBlockSubDivLocationForm.wards_mapped.id,// user?.wards?.map((ward: any) => ward.ward_id) ?? [],
          // "ulbIds": healthBlockSubDivLocationForm.ulb.id, //ulbByHealthBlockId[user.id]?.map((ulb: any) => ulb.ulb_id) ?? [],
          // "ulbCodes": healthBlockSubDivLocationForm.ulb.code, //user?.ulb?.map((ulb: any) => Number(ulb.split("-")[1])) ?? [],
          // "blockIds": healthBlockSubDivLocationForm.block.id, //blockByHealthBlockId[user.id]?.map((block: any) => block.block_id) ?? [],
          // "blockCodes": healthBlockSubDivLocationForm.block.code, //user?.block?.map((block: any) => Number(block.split("-")[1])) ?? [],
          // "subDistIds": healthBlockSubDivLocationForm.sub_district.id, //subDistrictByHealthBlockId[user.id]?.map((subDistrict: any) => subDistrict.sub_dist_id) ?? [],
          // "subDistCodes": healthBlockSubDivLocationForm.sub_district.code, //user?.sub_district?.map((sub_district: any) => Number(sub_district.split("-")[1])) ?? [],
          "ulbIds": [], //ulbByHealthBlockId[user.id]?.map((ulb: any) => ulb.ulb_id) ?? [],
          "blockIds": [], //blockByHealthBlockId[user.id]?.map((block: any) => block.block_id) ?? [],
          "subDistIds": [], //subDistrictByHealthBlockId[user.id]?.map((subDistrict: any) => subDistrict.sub_dist_id) ?? [],
          "parentUserId": '',
          "parentUserTypeId": ''
        }

        const data: any = await manageHealthFacilityJson(JSON.parse(JSON.stringify(payload)))
        const mainPayload = data.mainPayload;
        const combinedChunks: any[] = data.combinedChunks;

        const compressedMainData = pako.gzip(JSON.stringify(mainPayload));
        const encodeCompressedMainData = await uint8ToBase64(compressedMainData);

        let endpoint = endpoints.updateHealthBlockAndSubDiv;
        if (state === "upgrade") {
          endpoint = endpoints.upgradeHealthBlockAndSubDiv;
        }
        let response: any;
        if (combinedChunks.length > 0) {
          await axios.post(`${endpoint}`, {data: encodeCompressedMainData}, Auth.loggedInWithJSON()).then(async (res:any) => {
            if (res?.data) {
              response = res;
              let subRes: any
              for (const value of combinedChunks) {
                try {
                  const compressedDataWithIds = value ? pako.gzip(JSON.stringify({hbSdId: payload.hbSdId,
                    stCode: payload.stCode, ...value})) : null;
                  const encodeCompressedDataWithIds = compressedDataWithIds ? await uint8ToBase64(compressedDataWithIds) : '';
                  subRes = await putDataJSON<any>(`${endpoints.updateHealthBlockAndSubDivEntity}`, {data: encodeCompressedDataWithIds})
                } catch (err) {
                  toast.warning("Some ward/villages details could not be saved, try again.", {
                    position: "top-center"
                  });
                }
              }
              response = subRes ? subRes : res;
            } else {
              response = res;
            }
          });
        } else {
          response = await axios.post(`${endpoint}`, {data: encodeCompressedMainData}, Auth.loggedInWithJSON());
        }
        if (response.status === 200 || response?.data) {


          navigate(`/healthblock`);
          if (state === 'upgrade') {
            toast.success("Records have been successfully upgraded & saved", {
              position: "top-center"
            });
          }
          else {
            toast.success("Records have been successfully updated & saved", {
              position: "top-center"
            });
          }
        }
      }
      catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error)
      }
    }
  }

  return (
    <>{isLoading ? <div className="loader">Loading</div> :
      <div className='health_block_update_upgrade'>
        <div className="overview_healthBlockSubDiv_update">
          <div className="healthBlockSubDiv_update">
            {Component}
            <BadgesComponent
              className="over-badge"
              badgeName={healthBlockSubDiv.type_name === 'Health Block' ? "Health Block Details" : "Sub Division Details"}
              variant="primary-1"
              badgeType="case5"
            />
            <div className="overview-details-update">
              <div className="update_healthBlockSubDiv_details_page">
                <form className="update_container_healthBlockSubDiv_details">
                  <FormFields
                    formData={healthBlockSubDivData}
                    formState={healthBlockSubDivForm}
                    handleFormChange={handleHealthBlockSubDivFormChange}
                  />
                </form>
              </div>
              <hr></hr>
            </div>
          </div>
        </div>

        <div className="overview_healthBlockSubDiv_update">
          <div className="health_block location_update">
            <BadgesComponent
              className="over-badge"
              badgeName="Location Details"
              variant="primary-1"
              badgeType="case5"
            />
            <div className="overview-details-update">
              <div className="update_location_details_page">
                <form className="update_container_location_details_hb">
                  <FormFields
                    formData={healthBlockSubDivLocationData}
                    formState={healthBlockSubDivLocationForm}
                    handleFormChange={
                      (value: any, key: string, id: any, option: any, code: any) => {
                        const updateDropdownData = (dropdownData: any, setDropdownData: any, value: any, option: any) => {
                          id = [];
                          code = [];
                          option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
                            if (value.includes(op.value) && !dropdownData?.some((item: any) => item.id === op.id)) {
                              dropdownData?.push({
                                value: op.value,
                                label: op.value,
                                id: op.id,
                                code: op.code
                              });
                            }
                          });

                          const selectedData = dropdownData?.filter((item: any) => value?.includes(item.value));
                          setDropdownData(selectedData);
                          id = selectedData?.map((item: any) => item.id);
                          code = selectedData?.map((item: any) => item.code);
                        };


                        switch (key.toLowerCase()) {
                          case 'gram_panchayat_mapped': {
                            updateDropdownData(grampanchayatDropDownData, setGrampanchayatDropDownData, value, option);
                            break;
                          }
                          case 'ulb': {
                            updateDropdownData(ulbDropDownData, setUlbDropDownData, value, option);
                            break;
                          }
                          case 'wards_mapped': {
                            updateDropdownData(wardsDropDownData, setWardsDropDownData, value, option);
                            break;
                          }
                          case 'block': {
                            updateDropdownData(blockDropDownData, setBlockDropDownData, value, option);
                            break;
                          }
                          case 'villages_mapped': {
                            updateDropdownData(villages_mappedDropDownData, setViillagesMappedDropDownData, value, option);
                            break;
                          }
                          case 'sub_district': {
                            updateDropdownData(sub_districtDropDownData, setSubDistrictDropDownData, value, option);
                            break;
                          }
                          default:
                            break;
                        }
                        handleLocationForm(value, key, option, id, code);
                      }}
                    onInputChange={handleInputChange}
                  />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>}
    </>
  );
});
export default HealthBlockSubDivUpdateUpgrade;
HealthBlockSubDivUpdateUpgrade.displayName = 'HealthBlockSubDivUpdateUpgrade';


